module.exports = __webpack_public_path__ + "media/images/ico-theater@2x-1af8cf6c3fe77a00972b60bb4b93bffb.png";